export const map = Array.prototype.map;
export const slice = Array.prototype.slice;
